import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Icon, Spin } from "antd";

import styles from "./subLevel1Desktop.scss";
import { formatNumber, stringifyURI } from "../../../../services/utils";
import {
  ScreenSize,
  PageRoute,
  AllTypeCategory,
  AdsSortOption,
  QueryParam
} from "../../../../models";
import { getIconUrl, getImageLink } from "../../../../services/asset";
import FilterSection from "./FilterSection";

function SubLevel1Desktop(props: any) {
  const {
    level,
    categoryName,
    loading,
    isMakePage,
    module,
    numberOfControls,
    categories,
    selectedCategory,
    location
  } = props;
  const [rowCount, setrowCount] = useState(0);

  useEffect(() => {
    calculateHeight(props);

    window.addEventListener("resize", handleResize);

    const currentTotal = level.filter((l: any) => !l.logoId).length;

    if (currentTotal) {
      calculateHeight(props);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [level]);

  const handleResize = () => {
    calculateHeight(props);
  };

  const calculateHeight = (props: any) => {
    const { level } = props;
    const total = level.filter((l: any) => !l.logoId).length;
    const rowCount = Math.floor(total / getCategoryColumnNumber()) + 1;
    setrowCount(rowCount);
  };

  const getCategoryColumnNumber = () => {
    if (window.innerWidth >= ScreenSize.extraExtraLarge) {
      return 5;
    }

    if (window.innerWidth >= ScreenSize.extraLarge) {
      return 4;
    }

    if (window.innerWidth >= ScreenSize.large) {
      return 3;
    }

    return 2;
  };

  const renderIcon = (category: any) => {
    if (!category.checked) {
      return null;
    }

    return (
      <Icon
        className={styles.checkIcon}
        type="check"
        onClick={e => {
          e.preventDefault();
          props.onBoxClick(category.id);
        }}
      />
    );
  };

  const renderLogoCategory = (category: any, categoryName: any) => (
    <Link
      key={category.id}
      to={`${categoryName}/${category.id}`}
      title={category.name}
    >
      <span className={styles.logoCategory}>
        <img
          className={styles.circle}
          src={getImageLink(category.logoId)}
          alt={category.name}
        />
        <span className={styles.logoCategoryName}>{category.name}</span>
        {category.count ? (
          <span className={styles.logoCategoryCount}>
            {formatNumber(category.count)}
          </span>
        ) : null}
        {renderIcon(category)}
      </span>
    </Link>
  );

  const renderCategory = (category: any, categoryName: any) => (
    <span key={category.id} className={styles.categoryItemContainer}>
      <Link
        to={`${categoryName}/${category.route ? category.route : category.id}`}
        title={category.name}
      >
        <span className={styles.categoryName}>{category.name}</span>
        {category.count ? (
          <span className={styles.categoryCount}>
            {formatNumber(category.count)}
          </span>
        ) : null}
      </Link>
    </span>
  );

  const renderSearchAll = () => {
    const { module, categoryName, levelCount, isMakePage } = props;

    if (isMakePage) {
      return null;
    }

    const searchLink = `/${module}/${categoryName}${
      PageRoute.search
    }${stringifyURI({
      category: categoryName,
      module: module
    }, QueryParam.searchQuery)}`;

    return (
      <span className={styles.categoryItemContainer}>
        <Link to={searchLink} title={"Sve kategorije"}>
          <span className={styles.allName}>
            {"Sve kategorije"}
          </span>
          {levelCount ? (
            <span className={styles.categoryCount}>
              {formatNumber(levelCount)}
            </span>
          ) : null}
        </Link>
      </span>
    );
  };

  const renderSearchBtn = onClick => {
    return (
      <Button
        className={`uppercase ${styles.searchButton}`}
        onClick={onClick}
      >
        <img
          alt={"Traži"}
          src={getIconUrl("search-white.svg")}
        />
        {"Traži"}
      </Button>
    );
  };

  const handleFilterSubmit = (values, isToggle = false) => {
    const { onSubmit, module } = props;

    const sortOption = AdsSortOption.DateDesc;
    const localQueryParams = {
      ...values,
      page: 1,
      sortOption,
      category: props.categoryName
    };

    onSubmit(
      module === AllTypeCategory.name ? undefined : module,
      localQueryParams
    );
  };

  return (
    <React.Fragment>
      <div
        className={`child-center ${styles.container}`}
        style={{ marginTop: "16px" }}
      >
        {isMakePage ? (
          <div className={`child-center ${styles.filterContainer}`}>
            <FilterSection
              onSubmit={handleFilterSubmit}
              module={module === AllTypeCategory.name ? undefined : module}
              categories={categories}
              selectedCategory={selectedCategory}
              numberOfControls={numberOfControls}
              location={location}
              renderSearchBtn={renderSearchBtn}
              category={categoryName}
            />
          </div>
        ) : (
          <React.Fragment>
            {/* <div className={styles.logoCategoryContainer}>
              {level
                .filter((l: any) => l.logoId)
                .sort((l1: any, l2: any) => l1.logoOrder - l2.logoOrder)
                .map((l: any) => renderLogoCategory(l, categoryName))}
            </div> */}

            <span
              className={`${styles.categoryContainer} ${
                isMakePage ? "" : styles.nonLogoCategory
              }`}
              style={{ gridTemplateRows: `repeat(${rowCount}, 1fr)` }}
            >
              {renderSearchAll()}
              {level
                .filter((l: any) => !l.logoId)
                .map((l: any) => renderCategory(l, categoryName))}
            </span>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

SubLevel1Desktop.defaultProps = {
  level: [],
  levelCount: 0
};

export default SubLevel1Desktop;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/index.tsx